import { ApiService } from "./ApiService.js";

export class SupportService {
	static async enviarPedido({ nombres, documento, email, celular, dominio, detalle }, token = null) {
		const payload = {
			nombres: (nombres || "").trim(),
			documento: (documento || "").trim(),
			email: (email || "").trim(),
			celular: (celular || "").trim(),
			dominio: (dominio || "").trim(),
			detalle: (detalle || "").trim(),
		};
		const resp = await ApiService.post("apiapp/pedidosoporte", payload, token);
		return resp;
	}
}
